<template>
  <headboard></headboard>
  <div class="row">
    <div class="col-md-12">
      <assessment @savedAssessment="savedAssessment($event)" />
    </div>
  </div>
</template>
<script>
import assessment from "@/components/assessment/new-assessment.vue";

export default {
name: 'assessment-page',
components: {
assessment: assessment,

    },
methods: {
  savedAssessment(e){
    console.log("EEE-->",e)
    alert("guardado")
  }
}
}

</script>
